module.exports = __webpack_public_path__ + "static/media/29EUNOG8.6e3ff98f.jpg";